// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ogxL3","col":"styles_col__2I9YH"};